import { Gift, Mail, FileText, Sparkles } from 'lucide-react';

export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <Gift className="w-6 h-6 text-blue-400" />
              <h3 className="text-lg font-bold text-white">SwapGifts</h3>
            </div>
            <p className="text-gray-400 text-sm mb-4">
              The trusted platform for organizing gift exchanges worldwide. Free, secure, and easy to use.
            </p>
            <div className="flex gap-3">
              <a href="https://twitter.com/swapgifts" className="text-gray-400 hover:text-blue-400 transition-colors" aria-label="Twitter">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z" /></svg>
              </a>
              <a href="https://facebook.com/swapgifts" className="text-gray-400 hover:text-blue-400 transition-colors" aria-label="Facebook">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" /></svg>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-3 text-white">Popular Events</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/events/christmas" className="hover:text-blue-400 transition-colors">Christmas Secret Santa</a></li>
              <li><a href="/events/office-party" className="hover:text-blue-400 transition-colors">Office Parties</a></li>
              <li><a href="/events/birthday" className="hover:text-blue-400 transition-colors">Birthday Celebrations</a></li>
              <li><a href="/events/wedding" className="hover:text-blue-400 transition-colors">Wedding Parties</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-3 text-white">Tools & Features</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/create" className="hover:text-blue-400 transition-colors">Create Exchange</a></li>
              <li><a href="/gift-finder" className="hover:text-blue-400 transition-colors">Gift Finder</a></li>
              <li><a href="/budget-calculator" className="hover:text-blue-400 transition-colors">Budget Calculator</a></li>
              <li><a href="/gift-ideas" className="hover:text-blue-400 transition-colors">Gift Ideas Generator</a></li>
              <li><a href="/recover" className="hover:text-blue-400 transition-colors">Recover Links</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-3 text-white">Learn More</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/how-it-works" className="hover:text-blue-400 transition-colors">How It Works</a></li>
              <li><a href="/about" className="hover:text-blue-400 transition-colors">About Us</a></li>
              <li><a href="/blog" className="hover:text-blue-400 transition-colors">Blog & Articles</a></li>
              <li><a href="/faq" className="hover:text-blue-400 transition-colors">FAQ</a></li>
              <li><a href="/tech" className="hover:text-blue-400 transition-colors">Technology</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-3 text-white">Legal & Support</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li><a href="/terms" className="hover:text-blue-400 transition-colors">Terms of Service</a></li>
              <li><a href="/privacy" className="hover:text-blue-400 transition-colors">Privacy Policy</a></li>
              <li><a href="/refund-policy" className="hover:text-blue-400 transition-colors">Refund Policy</a></li>
              <li><a href="/support" className="hover:text-blue-400 transition-colors">Support Center</a></li>
              <li><a href="/feedback" className="hover:text-blue-400 transition-colors">Send Feedback</a></li>
              <li><a href="/sitemap.xml" className="hover:text-blue-400 transition-colors inline-flex items-center gap-1">
                <FileText className="w-3 h-3" />
                Sitemap
              </a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold mb-3 text-white">Our Apps</h4>
            <ul className="space-y-2 text-sm text-gray-400">
              <li>
                <a href="/autoaccept" className="hover:text-blue-400 transition-colors inline-flex items-center gap-1">
                  <Sparkles className="w-3 h-3" />
                  AutoAccept Antigravity
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-10 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-400">
            <p>&copy; {new Date().getFullYear()} Aritofu Labs. All rights reserved.</p>
            <div className="flex items-center gap-2">
              <Mail className="w-4 h-4" />
              <a href="mailto:support@swapgifts.com" className="hover:text-blue-400 transition-colors">
                support@swapgifts.com
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
